"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.typographyAligns = exports.typographyColors = exports.typographyComponents = exports.typographyVariants = void 0;

var _react = _interopRequireDefault(require("react"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    disabled: {
      color: theme.palette.text.disabled
    },
    regular: {
      fontWeight: 400
    },
    light: {
      fontWeight: 300
    },
    bold: {
      fontWeight: 700
    },
    VfGrey: {
      color: theme.palette.text.primary
    },
    VfRed: {
      color: theme.palette.primary.main
    },
    White: {
      color: theme.palette.common.white
    },
    Turquoise: {
      color: theme.palette.secondary.main
    },
    FreshOrange: {
      color: theme.palette.warning.main
    },
    UIGreen: {
      color: theme.palette.success.main
    },
    DarkGrey: {
      color: theme.palette.grey[800]
    },
    Anthracite: {
      color: theme.palette.grey[600]
    },
    MidGrey: {
      color: theme.palette.grey[500]
    }
  };
});
var mapTypographyProps = {
  "h1": {
    "variant": "h1"
  },
  "h2": {
    "variant": "h2"
  },
  "h3": {
    "variant": "h3"
  },
  "h4": {
    "variant": "h4"
  },
  "h5": {
    "variant": "h5"
  },
  "body": {
    "variant": "body1"
  },
  "bodySmall": {
    "variant": "body2"
  },
  "footerNote": {
    "variant": "caption"
  }
};

var Typography = function Typography(_ref) {
  var _classNames;

  var text = _ref.text,
      align = _ref.align,
      component = _ref.component,
      variant = _ref.variant,
      color = _ref.color,
      bold = _ref.bold,
      regular = _ref.regular,
      light = _ref.light,
      disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, ["text", "align", "component", "variant", "color", "bold", "regular", "light", "disabled"]);

  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_Typography.default, _extends({}, mapTypographyProps[variant], {
    align: align,
    component: component,
    variant: mapTypographyProps[variant].variant,
    className: (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, styles.bold, mapTypographyProps[variant].bold), _defineProperty(_classNames, styles.bold, bold), _defineProperty(_classNames, styles.regular, regular), _defineProperty(_classNames, styles.light, light), _defineProperty(_classNames, styles.disabled, disabled), _defineProperty(_classNames, styles[color], true), _classNames))
  }, props), text);
};

Typography.propTypes = {
  /** The text of the component */
  text: _propTypes.default.string.isRequired,

  /** The html semantic element */
  component: _propTypes.default.oneOf(["h1", "h2", "h3", "h4", "h5", "div", "p", "span"]),

  /** The color variants of the component */
  color: _propTypes.default.oneOf(["VfGrey", "VfRed", "White", "Turquoise", "FreshOrange", "UIGreen", "DarkGrey", "Anthracite", "MidGrey"]),

  /** The variants of the component */
  variant: _propTypes.default.oneOf(["h1", "h2", "h3", "h4", "h5", "body", "bodySmall", "footerNote"]),

  /** Font family bold */
  bold: _propTypes.default.bool,

  /** Font family regular */
  regular: _propTypes.default.bool,

  /** Font family light  */
  light: _propTypes.default.bool,

  /** Text disabled option */
  disabled: _propTypes.default.bool,

  /** The alignment of the text */
  align: _propTypes.default.oneOf(["left", "center", "right"])
};
Typography.defaultProps = {
  color: "VfGrey",
  variant: "body",
  component: "p",
  bold: false,
  light: false,
  disabled: false,
  regular: false,
  align: "left"
};
var typographyVariants = Object.keys(mapTypographyProps);
exports.typographyVariants = typographyVariants;
var typographyComponents = ["h1", "h2", "h3", "h4", "h5", "div", "p", "span"];
exports.typographyComponents = typographyComponents;
var typographyColors = ["VfGrey", "VfRed", "White", "Turquoise", "FreshOrange", "UIGreen", "DarkGrey", "Anthracite", "MidGrey"];
exports.typographyColors = typographyColors;
var typographyAligns = ["left", "center", "right"];
exports.typographyAligns = typographyAligns;
var _default = Typography;
exports.default = _default;